import React from "react";

import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import IJMEditorNavigator from "../../components/editors/ijm/IJMEditorNavigator";
import { useAtomValue } from "jotai";
import { editIjmSelectionCallback } from "../../atoms/core";

type IJMEditorNavScreenProps = StackScreenProps<RootStackParamList, "IJMEditorNavScreen">;

const IJMEditorNavScreen: React.FC<IJMEditorNavScreenProps> = ({ route }) => {
    const { ijmSelection, salaryInfo, cct, useLse } = route.params;
    const callback = useAtomValue(editIjmSelectionCallback);
    return (
        <IJMEditorNavigator
            ijmSelection={ijmSelection}
            salaryInfo={salaryInfo}
            cct={cct}
            useLse={useLse}
            onSave={callback.func}
        />
    );
};

export default IJMEditorNavScreen;
